module.exports = __webpack_public_path__ + "img/Sao Tome and Principe.8eb539e9.svg";